export const apiCalculatedAttributesAppGroupId = "/api/calculated_attributes/:app_group_id";
